import React from "react";
import styles from "./tech-course-info.module.css";
import ImageTag from "../image-tag";

const TechCourseInfo = ({ cards }) => {
  if (!cards?.length) return null;
  // Split cards into rows of 3 (like course-info)
  const rows = [];
  for (let i = 0; i < cards.length; i += 3) {
    rows.push(cards.slice(i, i + 3));
  }
  return (
    <section className={styles["section_first_background"]}>
      <div className={styles["background_section_body"]}>
        {rows.map((row, idx) => (
          <div className={styles["card_row"]} key={"row-" + idx}>
            {row.map((item) => (
              <div className={styles["card_item"]} key={item?.id}>
                <div className={styles["icon_card"]}>
                  <ImageTag imageUrl={item?.icons?.url} alt={item?.icons?.name} />
                  <div className={styles["card_title"]}>{item.card_title}</div>
                  <div className={styles["card_title"]}>{item.card_sub_title}</div>
                  <div className={styles["card_text"]}>{item.card_content}</div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};

export default TechCourseInfo;
